import React, { useState, useEffect } from 'react';
import '../styles/components/RegisterCheckbox.css';

function RegisterCheckbox({ requiredAgreed, setRequiredAgreed, formData, setFormData, loading, showProjectAlertConsent = false }) {
  // 내부 state: 3개 약관 체크박스 (방안1: 하위 호환성 유지)
  const [termsAgreed, setTermsAgreed] = useState(false);
  const [privacyAgreed, setPrivacyAgreed] = useState(false);
  const [thirdPartyAgreed, setThirdPartyAgreed] = useState(false);

  // 3개 모두 체크되면 부모에게 true 전달
  useEffect(() => {
    const allAgreed = termsAgreed && privacyAgreed && thirdPartyAgreed;
    setRequiredAgreed(allAgreed);
  }, [termsAgreed, privacyAgreed, thirdPartyAgreed, setRequiredAgreed]);

  // 부모의 requiredAgreed가 false로 리셋되면 내부도 리셋
  useEffect(() => {
    if (!requiredAgreed) {
      setTermsAgreed(false);
      setPrivacyAgreed(false);
      setThirdPartyAgreed(false);
    }
  }, [requiredAgreed]);

  const handleMarketing = (e) => setFormData({ ...formData, marketingOption: e.target.checked });

  const handleViewClick = (e, url) => {
    e.stopPropagation();
    window.open(url, '_blank');
  };

  return (
    <div className="register-checkbox">
      {/* 1. 서비스 이용약관 */}
      <label className="register-checkbox__label">
        <input
          type="checkbox"
          checked={termsAgreed}
          onChange={(e) => setTermsAgreed(e.target.checked)}
          disabled={loading}
          className="register-checkbox__input"
        />
        <span className="register-checkbox__text">
          서비스 이용약관에 동의합니다. (필수)
          <button 
            type="button"
            className="register-checkbox__view-link"
            onClick={(e) => handleViewClick(e, '/terms')}
            disabled={loading}
          >
            [보기]
          </button>
        </span>
      </label>

      {/* 2. 개인정보 수집 및 이용 */}
      <label className="register-checkbox__label">
        <input
          type="checkbox"
          checked={privacyAgreed}
          onChange={(e) => setPrivacyAgreed(e.target.checked)}
          disabled={loading}
          className="register-checkbox__input"
        />
        <span className="register-checkbox__text">
          개인정보 수집 및 이용에 동의합니다. (필수)
          <button 
            type="button"
            className="register-checkbox__view-link"
            onClick={(e) => handleViewClick(e, '/privacy-policy.html')}
            disabled={loading}
          >
            [보기]
          </button>
        </span>
      </label>

      {/* 3. 개인정보 제3자 제공 */}
      <label className="register-checkbox__label">
        <input
          type="checkbox"
          checked={thirdPartyAgreed}
          onChange={(e) => setThirdPartyAgreed(e.target.checked)}
          disabled={loading}
          className="register-checkbox__input"
        />
        <span className="register-checkbox__text">
          개인정보 제3자 제공에 동의합니다. (필수)
          <button 
            type="button"
            className="register-checkbox__view-link"
            onClick={(e) => handleViewClick(e, '/privacy-policy.html')}
            disabled={loading}
          >
            [보기]
          </button>
        </span>
      </label>

      {/* 4. 마케팅 수신 동의 (선택) */}
      <label className="register-checkbox__label">
        <input
          type="checkbox"
          checked={!!formData.marketingOption}
          onChange={handleMarketing}
          disabled={loading}
          className="register-checkbox__input"
        />
        <span className="register-checkbox__text">이벤트 등, 서비스 혜택을 안내해주세요. (선택)</span>
      </label>

      {/* 5·6. 프로젝트 알림 동의 — 인플루언서 전용 (showProjectAlertConsent={true} 전달 시에만 노출) */}
      {showProjectAlertConsent && (
        <>
          <label className="register-checkbox__label">
            <input
              type="checkbox"
              checked={!!formData.projectAlertEmail}
              onChange={e => setFormData(prev => ({ ...prev, projectAlertEmail: e.target.checked }))}
              disabled={loading}
              className="register-checkbox__input"
            />
            <span className="register-checkbox__text">희망단가 이상의 프로젝트 알림을 이메일로 받겠습니다. (선택)</span>
          </label>

          <label className="register-checkbox__label">
            <input
              type="checkbox"
              checked={!!formData.projectAlertSms}
              onChange={e => setFormData(prev => ({ ...prev, projectAlertSms: e.target.checked }))}
              disabled={loading}
              className="register-checkbox__input"
            />
            <span className="register-checkbox__text">희망단가 이상의 프로젝트 알림을 문자(SMS)로 받겠습니다. (선택)</span>
          </label>
        </>
      )}
    </div>
  );
}

export default RegisterCheckbox;